// import "./index.css";
// import Button from "@mui/material/Button";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
// import { useNavigate } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

// import { VAVE, GETIL2BYEMPID } from "../../AppConstant";

// import { Pagination, Stack } from "@mui/material";
// import Tooltip from "@mui/material/Tooltip";
// import { sourcingEmpIds } from "../switch_on_userlist";
// import ExcelTemplate from './excel_generate';

// function SwitchOn2B2List({}) {
//   const [refreshApi, setRefreshApi] = useState(false);
//   const [allIdeas, setAllIdeas] = useState([]);
//   const [selectedFilter, setSelectedFilter] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
//   const [reAssignOpenDialog, setreAssignOpenDialog] = useState(false);
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);
//   const [selectedIdea, setSelectedIdea] = useState(null);
//   const [createuri, setCreateuri] = useState("");
//   const navigate = useNavigate();
//   const currentEmpId = localStorage.getItem("empid");

//   const [showExcelTemplate, setShowExcelTemplate] = useState(false);

//   const handleDownloadExcel = (idea) => {
//     setSelectedIdea(idea);
//     setShowExcelTemplate(true);
//   };

//   const handleCloseExcel = () => {
//     setShowExcelTemplate(false);
//     setSelectedIdea(null);
//   };

//   const handleButtonClick = (filter) => {
//     setSelectedFilter(filter);
//     setCurrentPage(1);
//     handleFilter(filter);
//   };
//   const handleViewMore = (idea) => {
//     setSelectedIdea(idea);
//     setViewMoreOpenDialog(true);
//   };

//   const handleViewMoreCloseDialog = () => {
//     setViewMoreOpenDialog(false);
//     setSelectedIdea(null);
//   };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "accepted":
//         return "green";
//       case "rejected":
//         return "red";
//       case "inprogress":
//         return "orange";
//       default:
//         return "gray";
//     }
//   };

//   useEffect(() => {
//     fetchIdeas();
//   }, []);

//   useEffect(() => {
//     if (!refreshApi) return;
//     fetchIdeas();
//     handleFilter("inprogress");
//     setOpenDialog(false);
//     setreAssignOpenDialog(false);
//     setRefreshApi(false);
//   }, [refreshApi]);

//   const fetchIdeas = async () => {
//     const currentEmpId = localStorage.getItem("empid") || "";

//     try {
//       const response = await axios.get(VAVE + GETIL2BYEMPID, {
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//       });

//       const ideas = response.data.data || [];
//       setAllIdeas(ideas);
//       if (!refreshApi) {
//         handleFilter("All", ideas); // Initial filter
//       } else {
//         handleFilter("inprogress", ideas);
//       }
//       // handleFilter("All", ideas); // Initial filter
//     } catch (error) {
//       console.error("Error fetching ideas:", error);
//     }
//   };

//   const handleFilter = (filter, data = allIdeas) => {
//     const currentEmpId = localStorage.getItem("empid") || "";

//     let filtered = [];

//     if (filter === "All") {
//       filtered = data;
//     } else {
//       filtered = data.filter((idea) => {
//         if (idea.il2_costing_empid === currentEmpId) {
//           return (
//             idea.il2_costing_status?.toLowerCase() === filter.toLowerCase()
//           );
//         } else if (idea.il2_it_empid === currentEmpId) {
//           return idea.il2_it_status?.toLowerCase() === filter.toLowerCase();
//         } else if (idea.il2_pd_empid === currentEmpId) {
//           return idea.il2_pd_status?.toLowerCase() === filter.toLowerCase();
//         } else if (idea.il2_marketing_empid === currentEmpId) {
//           return (
//             idea.il2_marketing_status?.toLowerCase() === filter.toLowerCase()
//           );
//         } else if (idea.il2_manuf_busbody_empid === currentEmpId) {
//           return (
//             idea.il2_manuf_busbody_status?.toLowerCase() ===
//             filter.toLowerCase()
//           );
//         } else if (idea.il2_quality_empid === currentEmpId) {
//           return (
//             idea.il2_quality_status?.toLowerCase() === filter.toLowerCase()
//           );
//         } else if (idea.il2_manuf_hosur_empid === currentEmpId) {
//           return (
//             idea.il2_manuf_hosur_status?.toLowerCase() === filter.toLowerCase()
//           );
//         } else if (idea.il2_manuf_ennore_empid === currentEmpId) {
//           return (
//             idea.il2_manuf_ennore_status?.toLowerCase() === filter.toLowerCase()
//           );
//         } else if (idea.il2_sourcing_empid === currentEmpId) {
//           return (
//             idea.il2_sourcing_status?.toLowerCase() === filter.toLowerCase()
//           );
//         }
//         return false;
//       });
//     }

//     setIdeaListByEmpId(filtered);
//   };

//   const downloadfiles = (ee) => {
//     const hrefee = createuri;
//     const link = document.createElement("a");
//     link.href = hrefee;
//     link.setAttribute("download", +createuri + "_.pdf");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const filteredIdeas = ideaListByEmpId.filter((item) => {
//     const query = searchQuery.toLowerCase();
//     const matchesSearch = Object.values(item).some((value) =>
//       String(value).toLowerCase().includes(query)
//     );
//     // const matchesFilter =
//     //   selectedFilter === "All" ||
//     //   item.status?.toLowerCase() === selectedFilter.toLowerCase();
//     return matchesSearch;
//     // && matchesFilter;
//   });
//   const paginatedIdeas = filteredIdeas.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );
//   if (showExcelTemplate) {
//     return (
//       <ExcelTemplate
//         selectedFileData={selectedIdea}
//         onClose={handleCloseExcel}
//       />
//     );
//   }
//   return (
//     <div className="container mt-2">
//       <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
//         <div className="d-flex align-items-center">
//           <label className="me-2">Search</label>
//           <input
//             type="text"
//             className="form-control"
//             placeholder="Search..."
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value);
//               setCurrentPage(1);
//             }}
//             style={{ width: "200px" }}
//           />
//         </div>
//         <div className="d-flex gap-2">
//           <Button
//             variant="contained"
//             color={selectedFilter === "All" ? "success" : "primary"}
//             onClick={() => handleButtonClick("All")}
//           >
//             All
//           </Button>
//           <Button
//             variant="contained"
//             color={selectedFilter === "inprogress" ? "success" : "primary"}
//             onClick={() => handleButtonClick("inprogress")}
//           >
//             Pending
//           </Button>

//           <Button
//             variant="contained"
//             color={selectedFilter === "accepted" ? "success" : "primary"}
//             onClick={() => handleButtonClick("accepted")}
//           >
//             Accepted
//           </Button>
//           <Button
//             variant="contained"
//             color={selectedFilter === "rejected" ? "success" : "primary"}
//             onClick={() => handleButtonClick("rejected")}
//           >
//             Rejected
//           </Button>
//         </div>
//       </div>

//       <div className="table-responsive">
//         <table className="table table-bordered table-striped custom-table">
//           <thead className="thead-dark">
//             <tr>
//               <th>S.No</th>
//               {/* {selectedFilter === "All" && <th>Status</th>}
//               {selectedFilter === "inprogress" &&
//                 !iL1EmpIds.includes(currentEmpId) && <th>Reassign</th>} */}
//               <th>Proposed Idea</th>
//               <th>Part No</th>
//               <th>Savings</th>
//               <th>Upload Excel</th>
//               <th>Download Excel</th>
//               <th>View More</th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedIdeas.isEm}

//             {paginatedIdeas.map((req, index) => (
//               <tr key={req.id}>
//                 <td>{index + 1}</td>

//                 <td>
//                   {/* {" "} */}
//                   <Tooltip title={req.proposed_idea_x || ""} arrow>
//                     {/* <td> */}
//                     {req.proposed_idea_x?.slice(0, 15)}
//                     {req.proposed_idea_x?.length > 15 ? "..." : ""}
//                     {/* </td> */}
//                   </Tooltip>
//                 </td>

//                 <td>{req.partno}</td>

//                 <Tooltip title={req.benefit || ""} arrow>
//                   <td>
//                     {req.benefit?.slice(0, 15)}
//                     {req.benefit?.length > 15 ? "..." : ""}
//                   </td>
//                 </Tooltip>

//                 <td>{req.idea_effective}</td>

//                 <td>
//                   {" "}
//                   <button
//                     onClick={() => handleDownloadExcel(req)}
//                     className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
//                   >
//                     Download Excel
//                   </button>
//                 </td>

//                 <td
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handleViewMore(req)}
//                 >
//                   <FormatListBulletedIcon />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <Dialog
//         open={viewMoreOpenDialog}
//         onClose={handleViewMoreCloseDialog}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>Idea Details</DialogTitle>
//         <DialogContent>
//           {selectedIdea && (
//             <Grid container spacing={2}>
//               {/* Left Column */}
//               <Grid item xs={10} sm={6}>
//                 <Typography variant="body1">
//                   <strong>S.No:</strong>{" "}
//                   {ideaListByEmpId.indexOf(selectedIdea) + 1}
//                 </Typography>
//                 {/* <Typography variant="body1">
//                   <strong>Status:</strong>{" "}
//                   <span style={{ color: getStatusColor(selectedIdea.status) }}>
//                     {selectedIdea.status}
//                   </span>
//                 </Typography> */}
//                 <Typography variant="body1">
//                   <strong>Idea Category:</strong> {selectedIdea.idea_category_x}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Part No:</strong> {selectedIdea.partno}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Description:</strong> {selectedIdea.part_description}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea_x}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Current Condition:</strong>{" "}
//                   {selectedIdea.current_condition}
//                 </Typography>
//                 {sourcingEmpIds.includes(currentEmpId) ? (
//                   <Typography variant="body1">
//                     <strong>Comments:</strong>{" "}
//                     {selectedIdea.il1_sourcing_comment}
//                   </Typography>
//                 ) : (
//                   <Typography variant="body1">
//                     <strong>Comments:</strong> {selectedIdea.il1_pd_comment}
//                   </Typography>
//                 )}
//               </Grid>
//               {/* Right Column */}
//               <Grid item xs={12} sm={6}>
//                 <Typography variant="body1">
//                   <strong>Savings:</strong> {selectedIdea.benefit}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Aggregate:</strong> {selectedIdea.idea_effective}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Model:</strong> {selectedIdea.model}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Variant:</strong> {selectedIdea.varient}
//                 </Typography>

//                 <Typography variant="body1">
//                   <strong>Sub Variant:</strong> {selectedIdea.subvarient}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Domain:</strong> {selectedIdea.domain}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Function:</strong> {selectedIdea.function}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Location:</strong> {selectedIdea.location}
//                 </Typography>

//                 <Typography variant="body1">
//                   <strong>Document:</strong>{" "}
//                   {selectedIdea.filepath ? (
//                     <a
//                       href={selectedIdea.filepath}
//                       target="_blank"
//                       rel="noreferrer"
//                     >
//                       View File
//                     </a>
//                   ) : (
//                     "No File"
//                   )}
//                 </Typography>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleViewMoreCloseDialog} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Stack alignItems="center" marginTop={1} color="white">
//         <Pagination
//           count={totalPages}
//           page={currentPage}
//           onChange={(event, value) => setCurrentPage(value)}
//           color="primary"
//           variant="outlined"
//           shape="circular"
//           sx={{
//             "& .MuiPaginationItem-root": {
//               color: "black",
//               borderColor: "black",
//               backgroundColor: "white",
//             },
//             "& .Mui-selected": {
//               backgroundColor: "green",
//               color: "white",
//             },
//           }}
//         />
//       </Stack>
//     </div>
//   );
// }

// export default SwitchOn2B2List;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Tooltip,
  Pagination,
  Stack,
} from "@mui/material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  VAVE,
  UPLOAD2B2FILE,
  GET2B2DATA,
  DOWNLOADUPLOADEDUSERFILE,
} from "../../AppConstant";
import img from "../../../assets/images/switch_on_icon.png";
import AlertDialogForm from "./2b2_approval_dialog";
import loadergif from "../../../assets/images/BG-switch loader_2.gif";

function IdeaList({}) {
  const [refreshApi, setRefreshApi] = useState(false);
  const [allIdeas, setAllIdeas] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [reAssignOpenDialog, setreAssignOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [createuri, setCreateuri] = useState("");
  const navigate = useNavigate();
  const currentEmpId = localStorage.getItem("empid");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isloading, setIsloading] = useState(false);

  const isIdeaUpdatedToday = (idea) => {
    if (!idea?.url_2b2_created_timestamp) return false;

    const updatedDate = new Date(idea.url_2b2_created_timestamp)
      .toISOString()
      .split("T")[0];

    return updatedDate === "2025-11-20";
  };

  
  const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType =
          response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request.idea_unique_id}_User_Document.pdf`;

        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch((error) => {
        window.open(selectedIdea.filepath, "_blank");
        setIsloading(false);
      });
  };

  const handleDownloadExcel = async (idea) => {
    try {
      setIsloading(true);
      const gridData = createExcelGridData(idea);
      await downloadExcelWithGrid(gridData, idea);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      console.error("Error downloading Excel:", error);
      alert("Error downloading Excel file. Please try again.");
    }
  };

  const createExcelGridData = (idea) => {
    const rows = 70;
    const cols = 19;

    const gridData = Array.from({ length: rows }).map((_, r) =>
      Array.from({ length: cols }).map((_, c) => {
        return {
          r,
          c,
          value: "",
          bg: "#FFFFFF",
          font: { bold: false, size: 11 },
          alignment: { horizontal: "left", vertical: "center" },
          border: { top: false, left: false, bottom: false, right: false },
          colspan: 1,
          rowspan: 1,
          hidden: false,
          hasImage: false,
          imageUrl: "",
        };
      })
    );

    // Apply borders to all cells
    for (let r = 0; r < gridData.length; r++) {
      for (let c = 0; c < gridData[r].length; c++) {
        gridData[r][c].border = {
          top: { style: "thin", color: "#000000" },
          left: { style: "thin", color: "#000000" },
          bottom: { style: "thin", color: "#000000" },
          right: { style: "thin", color: "#000000" },
        };
      }
    }

    // === ROW 1 ===
    gridData[0][1].hasImage = true;
    gridData[0][1].imageUrl = img;
    gridData[0][1].colspan = 5;
    gridData[0][1].rowspan = 3;

    // Hide cells covered by the first image (B1 with colspan=5, rowspan=3)
    for (let r = 0; r < 3; r++) {
      for (let c = 2; c < 6; c++) {
        // Columns C to F (index 2 to 5)
        if (r === 0 && c === 1) continue; // Skip the main cell itself
        gridData[r][c].hidden = true;
      }
    }

    // Value Engineering Projects - spans columns G to N (8 columns) - colspan=8
    gridData[0][6].value = "Value Engineering Projects";
    gridData[0][6].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[0][6].alignment = { horizontal: "center", vertical: "center" };
    gridData[0][6].colspan = 8;
    gridData[0][6].rowspan = 2;
    gridData[0][6].bg = "#0E2841";

    for (let r = 0; r < 2; r++) {
      for (let c = 7; c < 14; c++) {
        // Columns H to N (index 7 to 13)
        if (r === 0 && c === 6) continue; // Skip the main cell itself
        gridData[r][c].hidden = true;
        gridData[r][c].bg = "#0E2841";
      }
    }

    gridData[2][6].value = " Signed off Report (2B2)";
    gridData[2][6].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[2][6].alignment = { horizontal: "center", vertical: "center" };
    gridData[2][6].colspan = 8;
    gridData[2][6].bg = "#808080";

    for (let c = 7; c < 12; c++) {
      if (c === 6) continue;
      gridData[2][c].hidden = true;
      gridData[2][c].bg = "#808080";
    }

    gridData[0][14].hasImage = true;
    gridData[0][14].imageUrl = img;
    gridData[0][14].colspan = 5;
    gridData[0][14].rowspan = 3;

    gridData[3][1].value = "Title";
    gridData[3][1].font = { bold: true, size: 14 };
    gridData[3][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[3][1].bg = "#C0E6F5";
    gridData[3][1].rowspan = 2;
    gridData[3][1].colspan = 3;
    gridData[3][4].colspan = 9;
    gridData[3][4].value = idea.idea_category;
    gridData[3][4].rowspan = 2;

    gridData[5][1].value = "Input / Request";
    gridData[5][1].font = { bold: true, size: 14 };
    gridData[5][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[5][1].bg = "#C0E6F5";
    gridData[5][1].colspan = 3;
    gridData[5][4].colspan = 9;

    gridData[5][4].value = idea.proposed_idea || "N/A";

    gridData[4][13].value = "Date";
    gridData[4][13].font = { bold: true, size: 14 };
    gridData[4][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[4][13].bg = "#C0E6F5";
    gridData[4][13].colspan = 3;
    gridData[4][16].colspan = 3;

    gridData[3][13].value = "Idea No";
    gridData[3][13].font = { bold: true, size: 14 };
    gridData[3][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[3][13].bg = "#C0E6F5";
    gridData[3][13].colspan = 3;
    gridData[3][16].colspan = 3;
    gridData[3][16].value = idea.idea_unique_id || "";
    gridData[5][13].value = "Group";
    gridData[5][13].font = { bold: true, size: 14 };

    gridData[5][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[5][13].bg = "#C0E6F5";
    gridData[5][13].colspan = 3;
    gridData[5][16].colspan = 3;

    gridData[6][1].value = "Cost saving \nestimation";
    gridData[6][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[6][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[6][1].bg = "#0E2841";
    gridData[6][1].colspan = 3;
    gridData[6][1].rowspan = 2;

    gridData[6][4].value = "Cost saving/Vehicle";
    gridData[6][4].font = { bold: true, size: 14 };
    gridData[6][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[6][4].bg = "#C0E6F5";
    gridData[6][4].colspan = 5;

    gridData[7][4].value = idea.benefit;
    gridData[7][4].font = { size: 14 };
    gridData[7][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[7][4].colspan = 5;

    gridData[6][9].value = "Volume considered (@ 54K)";
    gridData[6][9].font = { bold: true, size: 14 };
    gridData[6][9].alignment = { horizontal: "center", vertical: "center" };
    gridData[6][9].bg = "#C0E6F5";
    gridData[6][9].colspan = 5;

    // gridData[7][9].value = "api response";
    gridData[7][9].font = { size: 14 };
    gridData[7][9].alignment = { horizontal: "center", vertical: "center" };
    gridData[7][9].colspan = 5;

    gridData[6][14].value = "Cost Saving /Annum in Crs";
    gridData[6][14].font = { bold: true, size: 14 };
    gridData[6][14].alignment = { horizontal: "center", vertical: "center" };
    gridData[6][14].bg = "#C0E6F5";
    gridData[6][14].colspan = 5;

    // gridData[7][14].value = "10";
    gridData[7][14].font = { size: 14 };
    gridData[7][14].alignment = { horizontal: "center", vertical: "center" };
    gridData[7][14].colspan = 5;

    gridData[8][1].value = "Project /Part Details";
    gridData[8][1].font = { bold: true };
    gridData[8][1].colspan = 18;

    gridData[9][1].value = "Part Name";
    gridData[9][1].font = { bold: true, size: 14 };
    gridData[9][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[9][1].bg = "#C0E6F5";
    gridData[9][1].colspan = 3;

    gridData[9][4].value = idea.partno;
    gridData[9][4].font = { size: 14 };
    gridData[9][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[9][4].colspan = 6;

    gridData[10][1].value = "Assy & Affected Spec";
    gridData[10][1].font = { bold: true, size: 14 };
    gridData[10][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[10][1].bg = "#C0E6F5";
    gridData[10][1].colspan = 3;

    // gridData[10][4].value = "api response";
    gridData[10][4].font = { size: 14 };
    gridData[10][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[10][4].colspan = 6;

    gridData[11][1].value = "Part Obsolescence";
    gridData[11][1].font = { bold: true, size: 14 };
    gridData[11][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[11][1].bg = "#C0E6F5";
    gridData[11][1].colspan = 3;

    // gridData[11][4].value = "api response";
    gridData[11][4].font = { size: 14 };
    gridData[11][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[11][4].colspan = 6;

    gridData[9][10].value = "Part No";
    gridData[9][10].font = { bold: true, size: 14 };
    gridData[9][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[9][10].bg = "#C0E6F5";
    gridData[9][10].colspan = 3;

    gridData[9][13].value = idea.partno;
    gridData[9][13].font = { size: 14 };
    gridData[9][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[9][13].colspan = 6;

    gridData[10][10].value = "Vehicle Model";
    gridData[10][10].font = { bold: true, size: 14 };
    gridData[10][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[10][10].bg = "#C0E6F5";
    gridData[10][10].colspan = 3;

    gridData[10][13].value = idea.model;
    gridData[10][13].font = { size: 14 };
    gridData[10][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[10][13].colspan = 6;

    gridData[11][10].value = "Interchangeability";
    gridData[11][10].font = { bold: true, size: 14 };
    gridData[11][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[11][10].bg = "#C0E6F5";
    gridData[11][10].colspan = 3;

    // gridData[11][13].value = "api response";
    gridData[11][13].font = { size: 14 };
    gridData[11][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[11][13].colspan = 6;

    gridData[12][1].value = "Project Description";
    gridData[12][1].font = { bold: true };
    gridData[12][1].colspan = 18;

    gridData[13][1].value = idea.part_description;
    gridData[13][1].font = { size: 14 };
    gridData[13][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[13][1].colspan = 6;
    gridData[13][1].rowspan = 9;

    gridData[13][7].value = "Current Method";
    gridData[13][7].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[13][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[13][7].bg = "#0E2841";
    gridData[13][7].colspan = 6;

    gridData[14][7].font = { size: 14 };
    gridData[14][7].value = idea.current_condition;
    gridData[14][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[14][7].colspan = 6;
    gridData[14][7].rowspan = 7;

    gridData[21][7].value = "Part No's";
    gridData[21][7].font = { bold: true, size: 14 };
    gridData[21][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[21][7].colspan = 3;

    gridData[21][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[21][10].colspan = 3;

    gridData[13][13].value = "Proposed Method";
    gridData[13][13].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[13][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[13][13].bg = "#0E2841";
    gridData[13][13].colspan = 6;
    gridData[14][13].font = { size: 14 };
    gridData[14][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[14][13].colspan = 6;
    gridData[14][13].value = idea.proposed_idea;
    gridData[14][13].rowspan = 7;

    gridData[21][13].value = "Part No's";
    gridData[21][13].font = { bold: true, size: 14 };
    gridData[21][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[21][13].colspan = 3;

    gridData[21][16].alignment = { horizontal: "center", vertical: "center" };
    gridData[21][16].colspan = 3;
    gridData[22][1].colspan = 18;

    gridData[23][1].value = "Project Type";
    gridData[23][1].font = { bold: true, size: 14 };
    gridData[23][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][1].bg = "#C0E6F5";
    gridData[23][1].colspan = 2;
    gridData[23][1].rowspan = 2;

    gridData[24][1].colspan = 2;

    gridData[23][3].value = "Material Change";
    gridData[23][3].font = { bold: true, size: 14 };
    gridData[23][3].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][3].bg = "#C0E6F5";
    gridData[23][3].colspan = 2;
    gridData[24][3].colspan = 2;

    gridData[23][5].value = "Process Change";
    gridData[23][5].font = { bold: true, size: 14 };
    gridData[23][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][5].bg = "#C0E6F5";
    gridData[23][5].colspan = 2;
    gridData[24][5].colspan = 2;

    gridData[23][7].value = "Design Change";
    gridData[23][7].font = { bold: true, size: 14 };
    gridData[23][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][7].bg = "#C0E6F5";
    gridData[23][7].colspan = 2;
    gridData[24][7].colspan = 2;

    gridData[23][9].value = "De specification";
    gridData[23][9].font = { bold: true, size: 14 };
    gridData[23][9].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][9].bg = "#C0E6F5";
    gridData[23][9].colspan = 2;
    gridData[24][9].colspan = 2;

    gridData[23][11].value = "De featuring";
    gridData[23][11].font = { bold: true, size: 14 };
    gridData[23][11].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][11].bg = "#C0E6F5";
    gridData[23][11].colspan = 2;
    gridData[24][11].colspan = 2;

    gridData[23][13].value = "Horizontal dpmt";
    gridData[23][13].font = { bold: true, size: 14 };
    gridData[23][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][13].bg = "#C0E6F5";
    gridData[23][13].colspan = 2;
    gridData[24][13].colspan = 2;

    gridData[23][15].value = "Alt. Source";
    gridData[23][15].font = { bold: true, size: 14 };
    gridData[23][15].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][15].bg = "#C0E6F5";
    gridData[23][15].colspan = 2;
    gridData[24][15].colspan = 2;

    gridData[23][17].value = "Others";
    gridData[23][17].font = { bold: true, size: 14 };
    gridData[23][17].alignment = { horizontal: "center", vertical: "center" };
    gridData[23][17].bg = "#C0E6F5";
    gridData[23][17].colspan = 2;
    gridData[24][17].colspan = 2;

    gridData[25][1].value = "S.No";
    gridData[25][1].font = { bold: true };
    gridData[25][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[25][1].bg = "#D9E1F2";

    gridData[25][2].value = "Affected Systems";
    gridData[25][2].colspan = 4;
    gridData[25][2].font = { bold: true };
    gridData[25][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[25][2].bg = "#D9E1F2";

    gridData[25][6].value = "Connected changes / Interfaces";
    gridData[25][6].font = { bold: true };
    gridData[25][6].alignment = { horizontal: "center", vertical: "center" };
    gridData[25][6].bg = "#D9E1F2";
    gridData[25][6].colspan = 4;

    gridData[26][6].colspan = 4;
    gridData[27][6].colspan = 4;
    gridData[28][6].colspan = 4;
    gridData[29][6].colspan = 4;
    gridData[30][6].colspan = 4;
    gridData[31][6].colspan = 4;
    gridData[32][6].colspan = 4;
    gridData[33][6].colspan = 4;
    gridData[34][6].colspan = 4;
    gridData[35][6].colspan = 4;

    gridData[25][10].value = "S.No";
    gridData[25][10].font = { bold: true };
    gridData[25][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[25][10].bg = "#D9E1F2";

    gridData[25][11].value = "Affected Systems";
    gridData[25][11].font = { bold: true };
    gridData[25][11].alignment = { horizontal: "center", vertical: "center" };
    gridData[25][11].bg = "#D9E1F2";
    gridData[25][11].colspan = 4;

    gridData[25][15].value = "Connected changes / Interfaces";
    gridData[25][15].font = { bold: true };
    gridData[25][15].alignment = { horizontal: "center", vertical: "center" };
    gridData[25][15].bg = "#D9E1F2";
    gridData[25][15].colspan = 4;

    gridData[26][15].colspan = 4;
    gridData[27][15].colspan = 4;
    gridData[28][15].colspan = 4;
    gridData[29][15].colspan = 4;
    gridData[30][15].colspan = 4;
    gridData[31][15].colspan = 4;
    gridData[32][15].colspan = 4;
    gridData[33][15].colspan = 4;
    gridData[34][15].colspan = 4;
    gridData[35][15].colspan = 4;

    const leftSystems = [
      { sno: 1, system: "VI - LCV" },
      { sno: 2, system: "VI - Bus" },
      { sno: 3, system: "Bus FBS" },
      { sno: 4, system: "Cab & FBS" },
      { sno: 5, system: "Frame" },
      { sno: 6, system: "Suspension & Steering" },
      { sno: 7, system: "LV Harness" },
      { sno: 8, system: "Power electronic" },
      { sno: 9, system: "Clutch" },
      { sno: 10, system: "Gearbox" },
    ];

    leftSystems.forEach((item, index) => {
      const row = 26 + index;
      gridData[row][1].value = item.sno;
      gridData[row][1].alignment = { horizontal: "center", vertical: "center" };

      gridData[row][2].value = item.system;
      gridData[row][2].colspan = 4;
    });

    const rightSystems = [
      { sno: 11, system: "Propeller Shaft" },
      { sno: 12, system: "Axles" },
      { sno: 13, system: "Brakes" },
      { sno: 14, system: "HV cable" },
      { sno: 15, system: "Air Intake" },
      { sno: 16, system: "Cooling" },
      { sno: 17, system: "Thernal Systems" },
      { sno: 18, system: "Testing" },
      { sno: 19, system: "Homologation" },
      { sno: 20, system: "Attribute Engg" },
    ];

    rightSystems.forEach((item, index) => {
      const row = 26 + index;
      gridData[row][10].value = item.sno;
      gridData[row][10].alignment = {
        horizontal: "center",
        vertical: "center",
      };

      gridData[row][11].value = item.system;
      gridData[row][11].colspan = 4;
    });

    gridData[36][1].value = "Development and Validation check list";
    gridData[36][1].font = { bold: true };
    gridData[36][1].colspan = 18;

    gridData[37][1].value = "Validation Details";
    gridData[37][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][1].bg = "#0E2841";
    gridData[37][1].colspan = 3;

    gridData[37][4].value = "Y";
    gridData[37][4].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][4].bg = "#0E2841";

    gridData[37][5].value = "N";
    gridData[37][5].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][5].bg = "#0E2841";

    gridData[37][6].value = "Time";
    gridData[37][6].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][6].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][6].bg = "#0E2841";
    gridData[37][6].colspan = 2;
    gridData[38][6].colspan = 2;
    gridData[39][6].colspan = 2;
    gridData[40][6].colspan = 2;
    gridData[41][6].colspan = 2;
    gridData[42][6].colspan = 2;
    gridData[43][6].colspan = 2;
    gridData[44][6].colspan = 2;

    gridData[37][8].value = "Details";
    gridData[37][8].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][8].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][8].bg = "#0E2841";
    gridData[37][8].colspan = 2;
    gridData[38][8].colspan = 2;
    gridData[39][8].colspan = 2;
    gridData[40][8].colspan = 2;
    gridData[41][8].colspan = 2;
    gridData[42][8].colspan = 2;
    gridData[43][8].colspan = 2;
    gridData[44][8].colspan = 2;

    // === LEFT VALIDATION ITEMS (Rows 44-50) ===
    const leftValidationItems = [
      { item: "Bench Marking details" },
      { item: "Drawings/DFMEA/FMEA/    Layout Study" },
      { item: "CAE/FE analysis" },
      { item: "Part Development (Proto / Pilot)" },
      { item: "Material Analysis" },
      { item: "Dimensional Inspection" },
      { item: "Performance Prediction" },
    ];

    leftValidationItems.forEach((validation, index) => {
      const row = 38 + index;
      gridData[row][1].value = validation.item;
      gridData[row][1].colspan = 3;
    });

    gridData[37][10].value = "Validation Details";
    gridData[37][10].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][10].bg = "#0E2841";
    gridData[37][10].colspan = 3;

    gridData[37][13].value = "Y";
    gridData[37][13].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][13].bg = "#0E2841";

    gridData[37][14].value = "N";
    gridData[37][14].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][14].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][14].bg = "#0E2841";

    gridData[37][15].value = "Time";
    gridData[37][15].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][15].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][15].bg = "#0E2841";
    gridData[37][15].colspan = 2;
    gridData[38][15].colspan = 2;
    gridData[39][15].colspan = 2;
    gridData[40][15].colspan = 2;
    gridData[41][15].colspan = 2;
    gridData[42][15].colspan = 2;
    gridData[43][15].colspan = 2;
    gridData[44][15].colspan = 2;

    gridData[37][17].value = "Details";
    gridData[37][17].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[37][17].alignment = { horizontal: "center", vertical: "center" };
    gridData[37][17].bg = "#0E2841";
    gridData[37][17].colspan = 2;
    gridData[38][17].colspan = 2;
    gridData[39][17].colspan = 2;
    gridData[40][17].colspan = 2;
    gridData[41][17].colspan = 2;
    gridData[42][17].colspan = 2;
    gridData[43][17].colspan = 2;
    gridData[44][17].colspan = 2;

    // === RIGHT VALIDATION ITEMS (Rows 44-50) ===
    const rightValidationItems = [
      { item: "Performance testing" },
      { item: "Endurance testing" },
      { item: "Regulation/CMVR Approval" },
      { item: "Proto fitment /Plant fitment Sign-Off" },
      { item: "Field trials" },
      { item: "SAM Check" },
      { item: "Owner/Service manual and Brochure Changes" },
    ];

    rightValidationItems.forEach((validation, index) => {
      const row = 38 + index;
      gridData[row][10].value = validation.item;
      gridData[row][10].colspan = 3;
    });

    gridData[45][1].value = "Concurrence of related Dept function";
    gridData[45][1].font = { bold: true };
    gridData[45][1].colspan = 18;

    gridData[46][1].value = "Functions";
    gridData[46][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][1].bg = "#0E2841";
    gridData[46][1].colspan = 3;

    gridData[46][4].value = "Y";
    gridData[46][4].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][4].bg = "#0E2841";

    gridData[46][5].value = "N";
    gridData[46][5].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][5].bg = "#0E2841";

    gridData[46][6].value = "Remarks";
    gridData[46][6].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][6].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][6].bg = "#0E2841";
    gridData[46][6].colspan = 4;
    gridData[47][6].colspan = 4;
    gridData[48][6].colspan = 4;
    gridData[49][6].colspan = 4;
    gridData[50][6].colspan = 4;

    // === LEFT FUNCTIONS (Rows 55-58) ===
    const leftFunctions = [
      { func: "PD" },
      { func: "S&SC" },
      { func: "Quality" },
      { func: "Manufacturing" },
    ];

    leftFunctions.forEach((item, index) => {
      const row = 47 + index;
      gridData[row][1].value = item.func;
      gridData[row][1].colspan = 3;
    });

    gridData[46][10].value = "Functions";
    gridData[46][10].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][10].bg = "#0E2841";
    gridData[46][10].colspan = 3;

    gridData[46][13].value = "Y";
    gridData[46][13].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][13].bg = "#0E2841";

    gridData[46][14].value = "N";
    gridData[46][14].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][14].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][14].bg = "#0E2841";

    gridData[46][15].value = "Remarks";
    gridData[46][15].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[46][15].alignment = { horizontal: "center", vertical: "center" };
    gridData[46][15].bg = "#0E2841";
    gridData[46][15].colspan = 4;
    gridData[47][15].colspan = 4;
    gridData[48][15].colspan = 4;
    gridData[49][15].colspan = 4;
    gridData[50][15].colspan = 4;

    const rightFunctions = [
      { func: "Marketing" },
      { func: "Service" },
      { func: "Finance" },
      { func: "Others(Specify)" },
    ];

    rightFunctions.forEach((item, index) => {
      const row = 47 + index;
      gridData[row][10].value = item.func;
      gridData[row][10].colspan = 3;
    });

    gridData[51][1].colspan = 18;
    gridData[52][1].value = "Risk Statements";
    gridData[52][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[52][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[52][1].bg = "#0E2841";
    gridData[52][1].colspan = 3;
    gridData[52][1].rowspan = 2;
    gridData[52][4].rowspan = 2;
    gridData[52][4].colspan = 15;

    gridData[54][1].value = "Supplier Details";
    gridData[54][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[54][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[54][1].bg = "#0E2841";
    gridData[54][1].colspan = 6;
    gridData[55][1].colspan = 6;
    gridData[55][1].rowspan = 2;

    gridData[54][7].value = "Applicable Plants";
    gridData[54][7].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[54][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[54][7].bg = "#0E2841";
    gridData[54][7].colspan = 12;

    gridData[55][7].value = "Plant 1";
    gridData[55][7].font = { bold: true, size: 14 };
    gridData[55][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[55][7].bg = "#D9D9D9";
    gridData[55][7].colspan = 2;

    gridData[55][9].value = "Plant 2";
    gridData[55][9].font = { bold: true, size: 14 };
    gridData[55][9].alignment = { horizontal: "center", vertical: "center" };
    gridData[55][9].bg = "#D9D9D9";
    gridData[55][9].colspan = 2;

    gridData[55][11].value = "Plant 3";
    gridData[55][11].font = { bold: true, size: 14 };
    gridData[55][11].alignment = { horizontal: "center", vertical: "center" };
    gridData[55][11].bg = "#D9D9D9";
    gridData[55][11].colspan = 2;

    gridData[55][13].value = "Plant 4";
    gridData[55][13].font = { bold: true, size: 14 };
    gridData[55][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[55][13].bg = "#D9D9D9";
    gridData[55][13].colspan = 2;

    gridData[55][15].font = { bold: true, size: 14 };
    gridData[55][15].alignment = { horizontal: "center", vertical: "center" };
    gridData[55][15].bg = "#D9D9D9";
    gridData[55][15].colspan = 2;

    gridData[55][17].font = { bold: true, size: 14 };
    gridData[55][17].alignment = { horizontal: "center", vertical: "center" };
    gridData[55][17].bg = "#D9D9D9";
    gridData[55][17].colspan = 2;
    gridData[56][1].colspan = 18;
    gridData[57][1].value = "Total Time Estimation for completion - Months";
    gridData[57][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[57][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[57][1].bg = "#747474";
    gridData[57][1].colspan = 4;
    gridData[57][1].rowspan = 2;

    gridData[57][5].colspan = 5;
    gridData[57][5].rowspan = 2;

    gridData[57][10].value = "Special Skills/\n Additional resource/Budget";
    gridData[57][10].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[57][10].alignment = { horizontal: "center", vertical: "center" };
    gridData[57][10].bg = "#747474";
    gridData[57][10].colspan = 4;
    gridData[57][10].rowspan = 2;

    gridData[57][14].colspan = 5;
    gridData[57][14].rowspan = 2;

    gridData[58][1].colspan = 18;

    gridData[59][1].value = "Idea Feasibility";
    gridData[59][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[59][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[59][1].bg = "#0E2841";
    gridData[59][1].colspan = 4;

    gridData[60][1].value = "Feasible";
    gridData[60][1].colspan = 2;

    gridData[61][1].value = "Not Feasible";
    gridData[61][1].colspan = 2;

    gridData[59][5].value = "Justification/Remarks";
    gridData[59][5].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[59][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[59][5].bg = "#747474";
    gridData[59][5].colspan = 14;

    gridData[60][5].colspan = 14;
    gridData[61][5].colspan = 14;

    gridData[62][1].colspan = 18;
    gridData[63][4].rowspan = 7;

    gridData[63][1].value = "Team";
    gridData[63][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[63][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[63][1].bg = "#747474";
    gridData[63][1].colspan = 3;

    gridData[64][1].value = "Prepared By";
    gridData[64][1].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][1].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][1].bg = "#747474";
    gridData[65][1].rowspan = 5;

    gridData[64][2].value = "Checked By";
    gridData[64][2].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][2].bg = "#747474";
    gridData[65][2].rowspan = 5;

    gridData[64][3].value = "Approved By";
    gridData[64][3].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][3].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][3].bg = "#747474";
    gridData[65][3].rowspan = 5;

    gridData[63][5].value = "Sign-Off with related function";
    gridData[63][5].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[63][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[63][5].bg = "#747474";
    gridData[63][5].colspan = 14;

    gridData[64][5].value = "Domain";
    gridData[64][5].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][5].bg = "#747474";
    gridData[64][5].colspan = 2;

    gridData[65][5].value = "Comments";
    gridData[65][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[65][5].colspan = 2;
    gridData[65][5].rowspan = 2;

    gridData[67][5].value = "Sign";
    gridData[67][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[67][5].colspan = 2;
    gridData[67][5].rowspan = 3;

    gridData[64][7].value = "PD";
    gridData[64][7].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][7].bg = "#747474";
    gridData[64][7].colspan = 2;
    gridData[65][7].colspan = 2;
    gridData[65][7].rowspan = 2;
    gridData[67][7].colspan = 2;

    gridData[67][7].rowspan = 3;

    gridData[64][9].value = "S&SC";
    gridData[64][9].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][9].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][9].bg = "#747474";

    gridData[64][9].colspan = 2;
    gridData[65][9].colspan = 2;
    gridData[65][9].rowspan = 2;
    gridData[67][9].colspan = 2;
    gridData[67][9].rowspan = 3;
    // gridData[64][9].colspan = 2;
    // gridData[65][9].rowspan = 2;
    // gridData[65][10].rowspan = 2;
    // gridData[67][9].rowspan = 3;
    // gridData[67][10].rowspan = 3;

    gridData[64][11].value = "Manufac'g";
    gridData[64][11].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][11].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][11].bg = "#747474";

    gridData[64][11].colspan = 2;
    gridData[65][11].colspan = 2;
    gridData[65][11].rowspan = 2;
    gridData[67][11].colspan = 2;
    gridData[67][11].rowspan = 3;
    // gridData[64][11].colspan = 2;
    // gridData[65][11].rowspan = 2;
    // gridData[65][12].rowspan = 2;
    // gridData[67][11].rowspan = 3;
    // gridData[67][12].rowspan = 3;

    gridData[64][13].value = "Marktg/Service";
    gridData[64][13].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][13].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][13].bg = "#747474";
    gridData[64][13].colspan = 2;
    gridData[65][13].colspan = 2;
    gridData[65][13].rowspan = 2;
    gridData[67][13].colspan = 2;
    gridData[67][13].rowspan = 3;
    // gridData[64][13].colspan = 2;
    // gridData[65][13].rowspan = 2;
    // gridData[65][14].rowspan = 2;
    // gridData[67][13].rowspan = 3;
    // gridData[67][14].rowspan = 3;

    gridData[64][15].value = "Finance";
    gridData[64][15].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][15].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][15].bg = "#747474";
    gridData[64][15].colspan = 2;
    gridData[65][15].colspan = 2;
    gridData[65][15].rowspan = 2;
    gridData[67][15].colspan = 2;
    gridData[67][15].rowspan = 3;
    // gridData[64][15].colspan = 2;
    // gridData[65][15].rowspan = 2;
    // gridData[65][16].rowspan = 2;
    // gridData[67][15].rowspan = 3;
    // gridData[67][16].rowspan = 3;

    gridData[64][17].value = "Quality";
    gridData[64][17].font = { bold: true, size: 14, color: "#FFFFFF" };
    gridData[64][17].alignment = { horizontal: "center", vertical: "center" };
    gridData[64][17].bg = "#747474";
    gridData[64][17].colspan = 2;
    gridData[65][17].colspan = 2;
    gridData[65][17].rowspan = 2;

    gridData[67][17].colspan = 2;
    gridData[67][17].rowspan = 3;
    // gridData[64][17].colspan = 2;
    // gridData[65][17].rowspan = 2;
    // gridData[65][18].rowspan = 2;
    // gridData[67][17].rowspan = 3;
    // gridData[67][18].rowspan = 3;

    return gridData;
  };

  // const downloadExcelWithGrid = async (grid, idea) => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Value Engineering Projects");

  //   worksheet.properties.defaultColWidth = 15;
  //   worksheet.properties.defaultRowHeight = 20;

  //   const columnWidths = {
  //     1: 8,
  //     2: 12,
  //     3: 15,
  //     4: 12,
  //     5: 12,
  //     6: 12,
  //     7: 15,
  //     8: 12,
  //     9: 12,
  //     10: 12,
  //     11: 12,
  //     12: 15,
  //     13: 12,
  //     14: 12,
  //     15: 12,
  //     16: 15,
  //     17: 12,
  //     18: 12,
  //     19: 12,
  //     20: 12,
  //     21: 12,
  //   };

  //   Object.keys(columnWidths).forEach((col) => {
  //     worksheet.getColumn(parseInt(col)).width = columnWidths[col];
  //   });

  //   // First pass: Create all cells with basic styling
  //   grid.forEach((row, rowIndex) => {
  //     const excelRow = worksheet.getRow(rowIndex + 1);
  //     excelRow.height = 25;

  //     row.forEach((cell, colIndex) => {
  //       if (cell.hidden) return;

  //       const excelCell = excelRow.getCell(colIndex + 1);
  //       excelCell.value = cell.value || "";

  //       // Apply styling
  //       excelCell.style = {
  //         font: {
  //           name: "Arial",
  //           size: cell.font?.size || 11,
  //           bold: cell.font?.bold || false,
  //           color: { argb: fontColorToHex(cell.font?.color) || "FF000000" },
  //           italic: cell.font?.italic || false,
  //         },
  //         fill: {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: colorToHex(cell.bg) || "FFFFFFFF" },
  //         },
  //         alignment: {
  //           horizontal: cell.alignment?.horizontal || "left",
  //           vertical: cell.alignment?.vertical || "middle",
  //           wrapText: true,
  //         },
  //         border: {
  //           top: { style: "thin", color: { argb: "FF000000" } },
  //           left: { style: "thin", color: { argb: "FF000000" } },
  //           bottom: { style: "thin", color: { argb: "FF000000" } },
  //           right: { style: "thin", color: { argb: "FF000000" } },
  //         },
  //       };

  //       if (cell.alignment?.horizontal === "center") {
  //         excelCell.style.alignment.horizontal = "center";
  //       }
  //     });
  //   });

  //   // Second pass: Handle merged cells
  //   const mergedCells = [];

  //   grid.forEach((row, rowIndex) => {
  //     row.forEach((cell, colIndex) => {
  //       if (cell.hidden) return;

  //       const cellAddress = `${rowIndex + 1}-${colIndex + 1}`;

  //       if (mergedCells.includes(cellAddress)) return;

  //       const hasColspan = cell.colspan > 1;
  //       const hasRowspan = cell.rowspan > 1;

  //       if (hasColspan || hasRowspan) {
  //         const startRow = rowIndex + 1;
  //         const startCol = colIndex + 1;
  //         const endRow = hasRowspan ? rowIndex + cell.rowspan : rowIndex + 1;
  //         const endCol = hasColspan ? colIndex + cell.colspan : colIndex + 1;

  //         for (let r = startRow; r <= endRow; r++) {
  //           for (let c = startCol; c <= endCol; c++) {
  //             mergedCells.push(`${r}-${c}`);
  //           }
  //         }

  //         try {
  //           worksheet.mergeCells(startRow, startCol, endRow, endCol);

  //           const mergedCell = worksheet.getCell(startRow, startCol);
  //           mergedCell.style.alignment = {
  //             horizontal: cell.alignment?.horizontal || "left",
  //             vertical: cell.alignment?.vertical || "middle",
  //             wrapText: true,
  //           };

  //           mergedCell.style.font = {
  //             name: "Arial",
  //             size: cell.font?.size || 11,
  //             bold: cell.font?.bold || false,
  //             color: { argb: fontColorToHex(cell.font?.color) || "FF000000" },
  //             italic: cell.font?.italic || false,
  //           };
  //         } catch (error) {
  //           console.warn(`Could not merge cells:`, error.message);
  //         }
  //       }
  //     });
  //   });

  //   // Apply Arial font to all cells
  //   worksheet.eachRow((row) => {
  //     row.eachCell((cell) => {
  //       if (!cell.style.font) cell.style.font = {};
  //       cell.style.font.name = "Arial";

  //       if (!cell.style.alignment) cell.style.alignment = {};
  //       cell.style.alignment.vertical = "middle";
  //       cell.style.alignment.wrapText = true;
  //     });
  //   });

  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   // Use FileSaver.js for download
  //   saveAs(blob, `Idea_${idea.partno}_Report.xlsx`);
  // };

  // const colorToHex = (color) => {
  //   if (!color) return "FFFFFFFF";

  //   if (color.startsWith("#")) {
  //     return color.replace("#", "FF").toUpperCase();
  //   }

  //   const colorMap = {
  //     white: "FFFFFFFF",
  //     "#FFFFFF": "FFFFFFFF",
  //     "#0E2841": "FF0E2841",
  //     "#808080": "FF808080",
  //     "#C0E6F5": "FFC0E6F5",
  //     "#D9E1F2": "FFD9E1F2",
  //     "#F3F4F6": "FFF3F4F6",
  //   };

  //   return colorMap[color] || "FFFFFFFF";
  // };

  // const fontColorToHex = (color) => {
  //   if (!color) return "FF000000";

  //   if (color.startsWith("#")) {
  //     return color.replace("#", "FF").toUpperCase();
  //   }

  //   const colorMap = {
  //     white: "FFFFFFFF",
  //     black: "FF000000",
  //     "#FFFFFF": "FFFFFFFF",
  //     "#000000": "FF000000",
  //   };

  //   return colorMap[color] || "FF000000";
  // };

  // // Image to base64 function (optional - if you have images)
  // const imageToBase64 = async (imageUrl) => {
  //   try {
  //     if (typeof imageUrl === "string") {
  //       const response = await fetch(imageUrl);
  //       const blob = await response.blob();
  //       return new Promise((resolve) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //           const base64 = reader.result.split(",")[1];
  //           resolve(base64);
  //         };
  //         reader.readAsDataURL(blob);
  //       });
  //     }
  //     return null;
  //   } catch (error) {
  //     console.error("Error converting image to base64:", error);
  //     return null;
  //   }
  // };

  const downloadExcelWithGrid = async (grid, idea) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Value Engineering Projects");

    worksheet.properties.defaultColWidth = 15;
    worksheet.properties.defaultRowHeight = 20;

    const columnWidths = {
      1: 8,
      2: 12,
      3: 15,
      4: 12,
      5: 12,
      6: 12,
      7: 15,
      8: 12,
      9: 12,
      10: 12,
      11: 12,
      12: 15,
      13: 12,
      14: 12,
      15: 12,
      16: 15,
      17: 12,
      18: 12,
      19: 12,
    };

    Object.keys(columnWidths).forEach((col) => {
      worksheet.getColumn(parseInt(col)).width = columnWidths[col];
    });

    // First pass: Create all cells with basic styling
    grid.forEach((row, rowIndex) => {
      const excelRow = worksheet.getRow(rowIndex + 1);
      excelRow.height = 25;

      row.forEach((cell, colIndex) => {
        if (cell.hidden) return;

        const excelCell = excelRow.getCell(colIndex + 1);
        excelCell.value = cell.value || "";

        // Apply styling
        excelCell.style = {
          font: {
            name: "Arial",
            size: cell.font?.size || 11,
            bold: cell.font?.bold || false,
            color: { argb: fontColorToHex(cell.font?.color) || "FF000000" },
            italic: cell.font?.italic || false,
          },
          fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colorToHex(cell.bg) || "FFFFFFFF" },
          },
          alignment: {
            horizontal: cell.alignment?.horizontal || "left",
            vertical: cell.alignment?.vertical || "middle",
            wrapText: true,
          },
          border: {
            top: { style: "thin", color: { argb: "FF000000" } },
            left: { style: "thin", color: { argb: "FF000000" } },
            bottom: { style: "thin", color: { argb: "FF000000" } },
            right: { style: "thin", color: { argb: "FF000000" } },
          },
        };

        if (cell.alignment?.horizontal === "center") {
          excelCell.style.alignment.horizontal = "center";
        }
      });
    });

    // Handle images separately - pass workbook as parameter
    await addImagesToWorksheet(workbook, worksheet, grid);

    // Second pass: Handle merged cells
    const mergedCells = [];

    grid.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        if (cell.hidden) return;

        const cellAddress = `${rowIndex + 1}-${colIndex + 1}`;

        if (mergedCells.includes(cellAddress)) return;

        const hasColspan = cell.colspan > 1;
        const hasRowspan = cell.rowspan > 1;

        if (hasColspan || hasRowspan) {
          const startRow = rowIndex + 1;
          const startCol = colIndex + 1;
          const endRow = hasRowspan ? rowIndex + cell.rowspan : rowIndex + 1;
          const endCol = hasColspan ? colIndex + cell.colspan : colIndex + 1;

          for (let r = startRow; r <= endRow; r++) {
            for (let c = startCol; c <= endCol; c++) {
              mergedCells.push(`${r}-${c}`);
            }
          }

          try {
            worksheet.mergeCells(startRow, startCol, endRow, endCol);

            const mergedCell = worksheet.getCell(startRow, startCol);
            mergedCell.style.alignment = {
              horizontal: cell.alignment?.horizontal || "left",
              vertical: cell.alignment?.vertical || "middle",
              wrapText: true,
            };

            mergedCell.style.font = {
              name: "Arial",
              size: cell.font?.size || 11,
              bold: cell.font?.bold || false,
              color: { argb: fontColorToHex(cell.font?.color) || "FF000000" },
              italic: cell.font?.italic || false,
            };
          } catch (error) {
            console.warn(`Could not merge cells:`, error.message);
          }
        }
      });
    });

    // Apply Arial font to all cells
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        if (!cell.style.font) cell.style.font = {};
        cell.style.font.name = "Arial";

        if (!cell.style.alignment) cell.style.alignment = {};
        cell.style.alignment.vertical = "middle";
        cell.style.alignment.wrapText = true;
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `Idea_${idea.idea_unique_id}_Report.xlsx`);
  };

  // Updated function to accept workbook as parameter
  const addImagesToWorksheet = async (workbook, worksheet, grid) => {
    const imageCells = [];

    // Find all cells that have images
    grid.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        if (cell.hasImage && cell.imageUrl) {
          imageCells.push({
            row: rowIndex + 1,
            col: colIndex + 1,
            colspan: cell.colspan || 1,
            rowspan: cell.rowspan || 1,
            imageUrl: cell.imageUrl,
          });
        }
      });
    });

    // Process each image cell
    for (const imageCell of imageCells) {
      try {
        await addImageToCell(
          workbook,
          worksheet,
          imageCell.row,
          imageCell.col,
          imageCell.rowspan,
          imageCell.colspan,
          imageCell.imageUrl
        );
      } catch (error) {
        console.error(
          `Error adding image at row ${imageCell.row}, col ${imageCell.col}:`,
          error
        );
      }
    }
  };

  const addImageToCell = async (
    workbook,
    worksheet,
    startRow,
    startCol,
    rowspan,
    colspan,
    imageUrl
  ) => {
    try {
      // Fetch the image
      const response = await fetch(imageUrl);
      const imageBuffer = await response.arrayBuffer();

      // Add image to workbook
      const imageId = workbook.addImage({
        buffer: imageBuffer,
        extension: "png", // Change to 'jpeg' if needed
      });

      // Position the image in the cell area
      worksheet.addImage(imageId, {
        tl: { col: startCol - 1, row: startRow - 1 },
        br: { col: startCol - 1 + colspan, row: startRow - 1 + rowspan },
      });
    } catch (error) {
      console.error("Error processing image:", error);
      // Fallback: add text indicating image couldn't be loaded
      const cell = worksheet.getCell(startRow, startCol);
      cell.value = cell.value || "[Image]";
    }
  };

  const colorToHex = (color) => {
    if (!color) return "FFFFFFFF";
    if (color.startsWith("#")) {
      return color.replace("#", "FF");
    }
    const colorMap = {
      "#FFFFFF": "FFFFFFFF",
      "#0E2841": "FF0E2841",
      "#C0E6F5": "FFC0E6F5",
      "#808080": "FF808080",
      "#D9E1F2": "FFD9E1F2",
      "#D9D9D9": "FFD9D9D9",
      "#747474": "FF747474",
    };
    return colorMap[color] || "FFFFFFFF";
  };

  const fontColorToHex = (color) => {
    if (!color) return "FF000000";
    if (color.startsWith("#")) {
      return color.replace("#", "FF");
    }
    const colorMap = {
      "#FFFFFF": "FFFFFFFF",
      "#000000": "FF000000",
    };
    return colorMap[color] || "FF000000";
  };
  const handleButtonClick = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(1);
    handleFilter(filter);
  };

  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };

  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "green";
      case "rejected":
        return "red";
      case "inprogress":
        return "orange";
      default:
        return "gray";
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);

  useEffect(() => {
    if (!refreshApi) return;
    fetchIdeas();
    handleFilter("inprogress");
    setOpenDialog(false);
    setreAssignOpenDialog(false);
    setRefreshApi(false);
  }, [refreshApi]);

  const fetchIdeas = async () => {
    const currentEmpId = localStorage.getItem("empid") || "";

    try {
      const response = await axios.get(VAVE + GET2B2DATA, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response.data.data || [];
      setAllIdeas(ideas);
      if (!refreshApi) {
        handleFilter("All", ideas);
      } else {
        handleFilter("inprogress", ideas);
      }
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };

  const handleFilter = (filter, ideas = allIdeas) => {
    let filtered = ideas;

    if (filter === "completed") {
      filtered = ideas.filter(
        (item) =>
          item.upload_2d2_sheet_url !== null && item.upload_2d2_sheet_url !== ""
      );
    } else if (filter === "inprogress") {
      filtered = ideas.filter(
        (item) =>
          item.upload_2d2_sheet_url === null || item.upload_2d2_sheet_url === ""
      );
    } else {
      filtered = ideas;
    }

    setIdeaListByEmpId(filtered);
  };
  // const handleFilter = (filter, ideas = allIdeas) => {
  //   let filtered = ideas;

  //   if (filter === "completed") {
  //     filtered = ideas.filter((item) => item.docs_2b2_url !== null);
  //   }
  //   else if (filter === "inprogress") {
  //     filtered = ideas.filter((item) => item.docs_2b2_url === null || item.docs_2b2_url === "");
  //   }
  //   else {
  //     filtered = ideas;
  //   }

  //   setIdeaListByEmpId(filtered);
  // };

  const filteredIdeas = ideaListByEmpId.filter((item) => {
    const query = searchQuery.toLowerCase();
    return Object.values(item).some((value) =>
      String(value).toLowerCase().includes(query)
    );
  });

  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const uploadExcel = (request) => async (event) => {
    setIsloading(true);
    const file = event.target.files[0];
    if (!file) {
      setIsloading(false);

      return;
    }
    const validTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!validTypes.includes(file.type)) {
      event.target.value = "";
      setIsloading(false);

      alert("Please upload only Excel files (.xls or .xlsx).");

      return;
    }
    const expectedName = `Idea_${request.idea_unique_id}_Report`;

    const fileNameWithoutExt = file.name.replace(/\.xlsx?$/i, "");
    if (fileNameWithoutExt !== expectedName) {
      setIsloading(false);
      event.target.value = "";
      alert(`Please upload file with name: ${expectedName}.xlsx`);
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      event.target.value = "";
      alert("Upload size should not exceed 5 MB.");
      setIsloading(false);
      return;
    }

    await upload2b2File(file, request);

    setIsloading(false);
  };

  const upload2b2File = async (file, request) => {
    const formData = new FormData();
    formData.append("filepath", file);
    formData.append("type", "Excel");
    formData.append("idea_id", request.ideaid);
    formData.append("emp_id", localStorage.getItem("empid"));

    try {
      await axios.post(VAVE + UPLOAD2B2FILE, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setSelectedFile(file);
      alert("File uploaded successfully!");
    } catch (error) {
      console.error(error);
      alert("Upload failed. Please try again.");
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    // setSelectedRequest(null);
  };
  return (
    <div className="container mt-2">
      {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
        <div className="d-flex align-items-center">
          <label className="me-2">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            style={{ width: "200px" }}
          />
        </div>
        <div className="d-flex gap-2">
          <Button
            variant="contained"
            color={selectedFilter === "All" ? "success" : "primary"}
            onClick={() => handleButtonClick("All")}
          >
            All
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "inprogress" ? "success" : "primary"}
            onClick={() => handleButtonClick("inprogress")}
          >
            Pending
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "completed" ? "success" : "primary"}
            onClick={() => handleButtonClick("completed")}
          >
            Completed
          </Button>
          {/* <Button
            variant="contained"
            color={selectedFilter === "rejected" ? "success" : "primary"}
            onClick={() => handleButtonClick("rejected")}
          >
            Rejected
          </Button> */}
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              <th>Proposed Idea</th>
              <th>Part No</th>
              <th>Savings</th>
              <th>Template</th>

              {/* {selectedFilter === "inprogress" ? (
                <th>Upload Excel</th>
              ) : ( */}
              <th>Aggregate</th>
              {/* )}  */}
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            {paginatedIdeas.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No ideas found
                </td>
              </tr>
            ) : (
              paginatedIdeas.map((req, index) => (
                <tr key={req.id}>
                  <td>{req.idea_unique_id}</td>

                  {selectedFilter !== "inprogress" ? (
                    <td>
                      {" "}
                      <Tooltip title={req.proposed_idea || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea?.slice(0, 15)}
                        {req.proposed_idea?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  ) : (
                    <td
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "blue",
                      }}
                      onClick={() => {
                        setSelectedRequest(req);

                        setOpenDialog(true);
                      }}
                    >
                      <Tooltip title={req.proposed_idea || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea?.slice(0, 15)}
                        {req.proposed_idea?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  )}
                  <td>{req.partno}</td>
                  <td>
                    <Tooltip title={req.benefit || ""} arrow>
                      <span>
                        {req.benefit?.slice(0, 15)}
                        {req.benefit?.length > 15 ? "..." : ""}
                      </span>
                    </Tooltip>
                  </td>
                  {/* <td style={{ cursor: "pointer" }} onChange={uploadExcel}>
                    <UploadIcon />
                  </td> */}

                  {/* <td>
                    <button
                      onClick={() => handleDownloadExcel(req)}
                      // className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                    >
                      Download Excel
                    </button>
                  </td> */}

                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDownloadExcel(req)}
                  >
                    <DownloadIcon />
                  </td>

                  <td
                    style={{
                      cursor:
                        selectedFilter === "inprogress" ? "pointer" : "default",
                    }}
                  >
                    {/* {selectedFilter === "inprogress" ? (
                      <input
                        type="file"
                        onChange={uploadExcel(req)}
                        id="excelUpload"
                      />
                    ) : ( */}
                    <Tooltip title={req.idea_effective || ""} arrow>
                      <span>
                        {req.idea_effective?.slice(0, 15)}
                        {req.idea_effective?.length > 15 ? "..." : ""}
                      </span>
                    </Tooltip>
                    {/* )}  */}
                  </td>

                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => handleViewMore(req)}
                  >
                    <FormatListBulletedIcon />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                                  <strong>Employee Id:</strong> {selectedIdea.emp_id}
                                </Typography>
                                <Typography variant="body1">
                                  <strong>Employee Email:</strong> {selectedIdea.emp_email}
                                </Typography>
                <Typography variant="body1">
                  <strong>SW Id:</strong> {selectedIdea.idea_unique_id}
                </Typography>
                <Typography variant="body1">
                  <strong>Idea Category:</strong> {selectedIdea.idea_category}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient}
                </Typography>
                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location}
                </Typography>

                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                    <button
                    style={{
                        cursor: "pointer",
                        color: "blue",
                        border: "transparent",
                        background: "transparent",
                      }}
                      onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                    >
                      Download File
                    </button>
                  ) : (
                    "No File"
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Stack alignItems="center" marginTop={1} color="white">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "black",
              borderColor: "black",
              backgroundColor: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "green",
              color: "white",
            },
          }}
        />
      </Stack>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Request Details</DialogTitle>
        <DialogContent dividers>
          <AlertDialogForm
            response={selectedRequest}
            setRefreshApi={setRefreshApi}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default IdeaList;
